<template>
  <div class="box">
    <a-drawer
      :title="title"
      width="87vw"
      :visible="visible"
      :maskClosable="false"
      :mask="false"
      :confirmLoading="confirmLoading"
      :wrapClassName="wrapClassNameInfo()"
      @ok="handleOk"
      @close="handleCancel"
      cancelText="取消"
      okText="保存"
      :destroyOnClose="true">
        <a-row :gutter="24">
        <a-col :md="24">
          <a-card>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="6">
                    <a-form-item label="字典标签" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入字典标签查询" v-model="queryParam.dictLable"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6">
                    <a-form-item label="字典键值" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入字典键值查询" v-model="queryParam.dictValue"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                      <a-select  v-model="queryParam.status">
                        <a-select-option value="0">正常</a-select-option>
                        <a-select-option value="1">停用</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>

                  <a-col :md="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-col :md="6" :sm="24">
                        <a-button type="primary" @click="searchQuery">查询</a-button>
<!--                        <a-button style="margin-left: 8px" @click="searchReset({dictId: ruleId})">重置</a-button>-->
                      </a-col>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator"  style="margin-top: 5px">
              <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
              <!-- <a-button @click="batchDel" icon="delete">删除</a-button> -->
            </div>

            <!-- table区域-begin -->
            <div>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="nodeId"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                style="margin-bottom: 50px"
                @change="handleTableChange">
                <span slot="action" slot-scope="text, record">
                  <a @click="handleEdit(record)">编辑</a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.uuid)">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
                <!-- 状态渲染模板 -->
                <template slot="customRenderFlag" slot-scope="enabled">
                  <a-tag v-if="enabled==1" color="green">启用</a-tag>
                  <a-tag v-if="enabled==0" color="orange">禁用</a-tag>
                </template>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-drawer>

    <!-- 新增/编辑区域 -->
    <codeDict-modal ref="modalForm" @ok="modalFormOk" :ruleId="ruleId" :tableDataSource="dataSource"></codeDict-modal>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { dictList } from '@/api/identifierCode/identifierCode'
  import CodeDictModal from './codeDictModal2.vue'
  export default {
    name: "list",
    mixins:[JeecgListMixin],
    props: {
      uuid: { type: Array, required: true }
    },
    components: {
      CodeDictModal
    },
    data() {
      return {
        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },

        // 查询条件
        queryParam: {
          dictId: this.uuid
        },
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:40,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '30%',
            align:"center",
            scopedSlots: { customRender: 'action' },
          },
          {title: '字典标签 ', dataIndex: 'dictLable', width: 80, align:"center"},
          {title: '字典键值 ', dataIndex: 'dictValue', width: 80, align:"center"},
          {title: '状态', dataIndex: 'status', width: 80, align:"center",
            customRender: (qve) => {
              if (qve === '0') {
                return '正常';
              } else if (qve === '1') {
                return '停用';
              }
              return '未知状态';
            }
          },
          {title: '更新时间 ', dataIndex: 'updateTime', width: 80, align:"center"},
        ],
        url: {
          list: "/codeRules/fzNodeDictionaryData/page",
          delete: "/codeRules/fzNodeDictionaryData/delete",
          deleteBatch: "/codeRules/fzNodeDictionaryData/deleteBatch"
        },
        visibleRuleNode: false, // 规则节点抽屉开关
        ruleId: null,

        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{

        },
      }
    },
    methods: {
      // 规则节点 - 点击事件
      handleRuleNode() {
        this.visibleRuleNode = true
      },
      // 规则节点抽屉变化事件
      afterVisibleChange(val) {
        console.log('visible', val)
      },
      // 规则节点抽屉关闭 - 点击事件
      onClose() {
        this.visibleRuleNode = false;
      },
      getList(qve) {
        if(!qve){
          qve = this.ruleId
        }
        this.queryParam.dictId = qve
        this.ruleId = qve
        console.log('啊实打实大师', this.ruleId)

        let pageNo = this.ipagination.current
        let pageSize = this.ipagination.pageSize
        dictList({dictId: qve, pageNo: pageNo, pageSize: pageSize})
        .then(res => {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        })

        this.visible = true
      },
      handleTableChange(page,pageSize){
        this.ipagination.current = page.current
        this.ipagination.pageSize = page.pageSize
        dictList({dictId: this.ruleId, pageNo: this.ipagination.current, pageSize: this.ipagination.pageSize})
        .then(res => {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close()
        this.ipagination.current = 1
      },
    },
    created() {
      console.log('===', this.uuid)
    }
  }
</script>

<style scoped>
  @import '~@assets/less/common.less'
  /* .box {
    padding-bottom: 100px;
  } */
</style>